import styled from 'styled-components';

export const Container = styled.div`
  flex-grow: 1;
  padding: 0 2rem;
`;
